import React from 'react';
import { getBezierPath, getEdgeCenter } from 'react-flow-renderer';

const foreignObjectSize = 40;

const onEdgeClick = (evt, id) => {
    // evt.stopPropagation();
    alert(`remove ${id}`);
};

export default function CustomEdge({
    id,
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition,
    style = {},
    markerEnd,
    data
}) {
    const edgePath = getBezierPath({
        sourceX,
        sourceY,
        sourcePosition,
        targetX,
        targetY,
        targetPosition,
    });
    const [edgeCenterX, edgeCenterY] = getEdgeCenter({
        sourceX,
        sourceY,
        targetX,
        targetY,
    });

    const [edgeActive, setEdgeActive] = React.useState(false);

    const onDelete = (id) => {
        data.onDeleteEdge(id);
    }

    return (
        <>
            <path 
                style={style} 
                className="react-flow__edge-path-selector"
                d={edgePath} 
                markerEnd={markerEnd} 
                fillRule="evenodd" 
                />
            <path
                id={id}
                style={style}
                className="react-flow__edge-path"
                d={edgePath}
                markerEnd={markerEnd}
            />

            <foreignObject
                width={foreignObjectSize}
                height={foreignObjectSize}
                x={edgeCenterX - foreignObjectSize / 2}
                y={edgeCenterY - foreignObjectSize / 2}
                className="edgebutton-foreignobject"
                requiredExtensions="http://www.w3.org/1999/xhtml"
            >
                <body>
                <button className="edgebutton" onClick={e => onDelete(id)}>
                    ×
                </button>
                </body>
            </foreignObject>
        </>
    );
}
